import { assoc, compose, map, prop, sortBy } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { MAIN_COL_WIDTH, PADDING_COL_WIDTH, useModules } from './_constants'
import IconText from '../../../../packages/kiti/components/presentation/IconText'
import LineSeparator from '../../../../packages/kiti/components/helpers/LineSeparator'
import Link from '../../../../packages/kiti/components/actions/Link'
import PermissionsLoader from '../_load/PermissionsLoader'
import PermissionsRows from './PermissionsRows'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const ModuleRow = ({ name, permissions }) => {
  const { t } = useTranslation('editPermissions')
  const [open, setOpen] = React.useState(false)
  const toggle = () => setOpen(!open)

  return (
    <div>
      <Grid>
        <Col width={PADDING_COL_WIDTH} />
        <Col width={MAIN_COL_WIDTH} flex={1}>
          <Link onClick={toggle}>
            <IconText
              iconLeft={!open ? 'RiAddCircleLine' : 'RiIndeterminateCircleLine'}
              iconSize={1.2}
              gutter={0.3}
              color="dark2"
              size="h5"
              bold
              label={t(`modules.${name}.title`, name)}
            />
          </Link>
        </Col>
      </Grid>

      {open && (
        <>
          <Separator weight={4} />
          <PermissionsRows permissionDefinitions={permissions} />
        </>
      )}

      <LineSeparator color="light5" weight={4} />
    </div>
  )
}

const ModulesRows = () => {
  const { t } = useTranslation('editPermissions')
  const modules = useModules()

  const sortedModules = React.useMemo(
    () =>
      compose(
        sortBy(prop('sort')),
        map(item => assoc('sort', t(`modules.${item.name}.title`, item.name), item)) //
      )(modules),
    [modules, t]
  )

  return (
    <PermissionsLoader>
      {sortedModules.map(({ name, permissions }) => (
        <ModuleRow key={name} name={name} permissions={permissions} />
      ))}
    </PermissionsLoader>
  )
}

export default ModulesRows
